export * from './detail-base.component';
export * from './detail-options.model';
export * from './detail.model';
